const populateActionWithIntegrationDetails = (action, app) => ({
	...action,
	service_slug: app.service_slug,
	service_name: app.service_name,
});

const ActionsMenuService = { populateActionWithIntegrationDetails };

export default ActionsMenuService;
